(() => {
  const mini = document.querySelector('[data-gtm]');
  if (!mini) return;
  if (Date.now() > Date.parse(mini.dataset.close)) return; /* entries closed: no more ticket */
  /* live on <html> itself (like the back-to-top button) so nothing on the page can clip or hide it */
  document.documentElement.appendChild(mini);
  const slot = document.createElement('div');
  slot.className = 'gtm-slot';
  slot.setAttribute('aria-hidden', 'true');
  document.documentElement.appendChild(slot);

  /* Oct 12 (night): sold out. When every spot on the wheel is taken, the ticket points people to the
     next-drawing signup instead of "Enter to win". */
  const soldOut = () => {
    if (mini.classList.contains('is-full')) return;
    mini.classList.add('is-full');
    const set = (sel, html) => { const el = mini.querySelector(sel); if (el) el.innerHTML = html; };
    set('.gtm__k', '&#9733; Sold out &#9733;');
    set('.gtm__t', 'All tickets have<br>been claimed');
    set('.gtm__b', 'Notify me');
    set('.gtm__r', 'for the next drawing');
    mini.setAttribute('href', '/pages/wheel#next-drawing');
    mini.setAttribute('aria-label', 'All tickets have been claimed. Tap to get notified about the next drawing');
  };
  if (/(?:^|[?&])dn_preview=full(?:&|$)/.test(location.search.slice(1))) soldOut();
  else if (mini.dataset.backend) {
    const KEY = 'gtm-wheel-full';
    let cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (cached && Date.now() - cached.t < 5 * 60 * 1000) { if (cached.full) soldOut(); }
    else if (window.fetch) {
      const ctl = window.AbortController ? new AbortController() : null;
      const tm = setTimeout(() => { if (ctl) ctl.abort(); }, 6000);
      fetch(mini.dataset.backend.replace(/\/$/, '') + '/wheel', { credentials: 'omit', cache: 'no-store', signal: ctl ? ctl.signal : undefined })
        .then((r) => (r.ok ? r.json() : null))
        .then((w) => {
          if (!w) return;
          const full = !w.draw && w.acceptingEntries === false && Array.isArray(w.ideas) && w.ideas.length >= 41;
          try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), full })); } catch (e) {}
          if (full) soldOut();
        })
        .catch(() => {})
        .finally(() => clearTimeout(tm));
    }
  }

  /* sit above Shopify's preview bar (store owner only) */
  const lift = () => {
    const pb = document.querySelector('#preview-bar-iframe, #PBarNextFrameWrapper, #PBarNextFrame, iframe[id*="preview-bar"], iframe[src*="preview_bar"]');
    let up = 0;
    if (pb) {
      const cs = getComputedStyle(pb), r = pb.getBoundingClientRect(), vh = window.innerHeight;
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.bottom >= vh - 4 && r.top < vh) up = Math.max(0, vh - r.top);
    }
    mini.style.setProperty('--gtm-lift', Math.round(up) + 'px');
    slot.style.setProperty('--gtm-lift', Math.round(up) + 'px');
    if (parked && !held && !flying) { s.y = floorY(); paint(); }
  };
  [300, 1500, 3500, 7000].forEach((ms) => setTimeout(lift, ms));
  window.addEventListener('resize', lift);

  /* slide away while scrolling down, come back on any scroll up or near the top */
  let lastY = window.scrollY || 0, ticking = false;
  const onScroll = () => {
    if (ticking || held || flying) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      const y = Math.max(0, window.scrollY || document.documentElement.scrollTop || 0);
      const d = y - lastY;
      if (y < 80 || d < -6) { mini.classList.remove('is-tucked'); lastY = y; }
      else if (d > 6) { mini.classList.add('is-tucked'); lastY = y; }
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  /* step aside while typing so it never covers a text box */
  const typing = (el) => el && el.matches && el.matches('input, textarea, select');
  document.addEventListener('focusin', (e) => { if (typing(e.target)) mini.classList.add('is-away'); });
  document.addEventListener('focusout', () => { setTimeout(() => { if (!typing(document.activeElement)) mini.classList.remove('is-away'); }, 300); });

  /* ---------- Oct 12: pick it up, throw it, park it, put it back ---------- */
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
  const rnd = (lo, hi) => lo + Math.random() * (hi - lo);
  const RAD = Math.PI / 180;
  /* x, y in px from the normal spot; a = spin (deg); fx / fy = paper tilt (deg); k = size;
     r = how much it's lying back on the bar (1 = parked pose, 0 = upright) */
  const s = { x: 0, y: 0, a: 0, fx: 0, fy: 0, k: 1, r: 0 };
  const REST_A = -6, REST_X = 32; /* parked: a little crooked, tipped back like it's lying on the bar */
  const PARK_K = 0.56;            /* parked size */
  const SNAP = 95;                /* how close to the spot counts as "put back" (px) */
  const IMPACT = 900;             /* Oct 20: hitting the bottom of the screen this hard (px/s) breaks it */
  let held = null, moved = false, flying = false, parked = false, anim = 0, blockClick = false;
  let shattered = false;
  const W = () => window.innerWidth || 390;
  const H = () => window.innerHeight || 800;
  const w0 = () => mini.offsetWidth || 178;
  const h0 = () => mini.offsetHeight || 100;

  const paint = () => {
    mini.style.transform = 'perspective(700px) translate3d(' + s.x.toFixed(1) + 'px,' + s.y.toFixed(1) + 'px,0) rotate(' + (s.a + REST_A * s.r).toFixed(2) + 'deg) rotateX(' + (s.fx + REST_X * s.r).toFixed(2) + 'deg) rotateY(' + s.fy.toFixed(2) + 'deg) scale(' + s.k.toFixed(3) + ')';
  };
  /* h = how high off the page it is (0 lying flat, 1 held up) */
  const shadow = (h) => { mini.style.filter = 'drop-shadow(0 ' + Math.round(2 + h * 14) + 'px ' + Math.round(3 + h * 19) + 'px rgba(0,0,0,' + (0.42 - h * 0.04).toFixed(2) + '))'; };

  /* where the ticket's center has to sit (relative to its normal spot) for its edge to rest on
     the bottom of the screen at size k, turned by angle a */
  const gap = () => Math.max(0, H() - (mini.offsetTop + h0()));
  const halfH = (k, a) => (h0() / 2 * Math.abs(Math.cos(a * RAD)) + w0() / 2 * Math.abs(Math.sin(a * RAD))) * k;
  const halfW = (k, a) => (w0() / 2 * Math.abs(Math.cos(a * RAD)) + h0() / 2 * Math.abs(Math.sin(a * RAD))) * k;
  const floorY = (k = PARK_K, a = REST_A) => gap() + h0() / 2 - halfH(k, a) * Math.cos(REST_X * RAD) - 1;
  const wallX = (k = PARK_K, a = REST_A) => Math.max(0, W() / 2 - halfW(k, a) - 6);

  const save = () => {
    try {
      if (parked) sessionStorage.setItem('gtm-parked', String(Math.round(s.x)));
      else sessionStorage.removeItem('gtm-parked');
    } catch (e) {}
  };

  /* the ticket's state is saved as soon as it starts to fall. If it lands on the ground it shatters (menu bar).
     If the page changes before it lands, it comes back to normal on the next page. */
  const setFalling = (on) => {
    try { if (on) sessionStorage.setItem('gtm-falling', '1'); else sessionStorage.removeItem('gtm-falling'); } catch (e) {}
  };

  /* spring every value to its target: a quick, slightly bouncy settle */
  const springTo = (target, done) => {
    cancelAnimationFrame(anim);
    const v = { x: 0, y: 0, a: 0, fx: 0, fy: 0, k: 0, r: 0 };
    const K = 300, D = 20;
    let t0 = performance.now();
    const step = (now) => {
      const dt = Math.min(0.032, (now - t0) / 1000); t0 = now;
      let still = true;
      Object.keys(target).forEach((p) => {
        const tg = typeof target[p] === 'function' ? target[p]() : target[p];
        if (reduce) { s[p] = tg; return; }
        v[p] += (-K * (s[p] - tg) - D * v[p]) * dt;
        s[p] += v[p] * dt;
        const tol = (p === 'k' || p === 'r') ? 0.004 : 0.3;
        if (Math.abs(s[p] - tg) > tol || Math.abs(v[p]) > 2) still = false;
      });
      paint();
      shadow(clamp((s.k - (parked ? PARK_K : 1)) / 0.1, 0, 1));
      if (still || reduce) {
        Object.keys(target).forEach((p) => { s[p] = typeof target[p] === 'function' ? target[p]() : target[p]; });
        paint();
        if (done) done();
        return;
      }
      anim = requestAnimationFrame(step);
    };
    anim = requestAnimationFrame(step);
  };

  /* back in its normal spot: full size, upright, idle wiggle again */
  const home = () => {
    setFalling(false);
    parked = false; save();
    mini.classList.remove('is-parked', 'is-flying');
    springTo({ x: 0, y: 0, a: 0, fx: 0, fy: 0, k: 1, r: 0 }, () => {
      mini.style.transform = '';
      mini.style.filter = '';
      mini.classList.remove('is-held');
      mini.style.animation = reduce ? 'none' : 'gtm-wiggle 6s ease-in-out 3s infinite';
    });
  };

  /* lie down on the bottom edge where it landed */
  const park = () => {
    setFalling(false);
    flying = false;
    parked = true;
    mini.classList.remove('is-flying', 'is-held');
    mini.classList.add('is-parked');
    mini.style.animation = 'none';
    /* finish any flip the short way round so the front ends up facing you */
    const near = (d) => d - 360 * Math.round(d / 360);
    s.fx = near(s.fx); s.fy = near(s.fy); s.a = near(s.a);
    const x = clamp(s.x, -wallX(), wallX());
    springTo({ x: x, y: () => floorY(), a: 0, fx: 0, fy: 0, k: PARK_K, r: 1 }, () => { shadow(0); save(); });
  };

  /* thrown or dropped: real momentum, gravity, air and paper flutter, bouncing off the
     bottom and side edges until it settles on the bottom. A hard enough hit on the bottom breaks it. */
  const toss = (vx, vy, va, gx, gy) => {
    cancelAnimationFrame(anim);
    flying = true;
    setFalling(true);
    mini.classList.remove('is-held');
    mini.classList.add('is-flying');
    if (reduce) { park(); return; }
    const w = w0(), h = h0();
    /* off-center grab = torque: a ticket thrown by one corner spins */
    let wa = va * 0.5 + (vx * (-gy / (h / 2)) + vy * (gx / (w / 2))) * 0.38 + rnd(-60, 60);
    /* hard flicks tumble end over end (a loop) */
    const sp = Math.hypot(vx, vy);
    let wfx = -vy * 0.3 + rnd(-90, 90);
    let wfy = vx * 0.28 + rnd(-90, 90);
    if (sp > 1500) { wfx *= 1.4; wa *= 1.2; }
    const G = 1600, AIR = 0.0011, SPIN_AIR = 0.6;
    let t0 = performance.now(), age = 0, onFloor = 0;
    const step = (now) => {
      const dt = Math.min(0.032, (now - t0) / 1000); t0 = now; age += dt;
      const v = Math.hypot(vx, vy);
      /* paper glides sideways toward the edge it's tipped to, more as it slows */
      const glide = Math.sin(s.fy * RAD) * 420 * (1 - clamp(v / 1400, 0, 1));
      vx += (-AIR * vx * v + glide) * dt;
      vy += (G - AIR * vy * v) * dt;
      s.x += vx * dt; s.y += vy * dt;
      const sd = Math.exp(-SPIN_AIR * dt);
      wa *= sd; wfx *= sd; wfy *= sd;
      s.a += wa * dt; s.fx += wfx * dt; s.fy += wfy * dt;
      /* shrinks and starts lying back as it falls toward the bottom */
      s.k += (PARK_K - s.k) * Math.min(1, dt * 2.6);
      s.r += (0.6 - s.r) * Math.min(1, dt * 2);
      /* side edges */
      const wx = W() / 2 - halfW(s.k, s.a) - 2;
      if (s.x > wx && vx > 0) { s.x = wx; vx = -vx * 0.45; wa = -wa * 0.6; }
      if (s.x < -wx && vx < 0) { s.x = -wx; vx = -vx * 0.45; wa = -wa * 0.6; }
      /* bottom edge */
      const fy = floorY(s.k, s.a);
      if (s.y >= fy && vy > 0) {
        s.y = fy;
        /* hit the ground hard enough: it breaks like tempered glass */
        if (!reduce && vy > IMPACT) { shatter(vx, vy, wa); return; }
        onFloor++;
        if (vy > 260) {
          vy = -vy * 0.3;
          vx *= 0.7; wa *= 0.5; wfx *= 0.35; wfy *= 0.35;
        } else {
          vy = 0;
        }
      }
      if (s.y >= fy - 0.5) {
        /* on the bottom: it slides to a stop and falls flat instead of standing on its edge */
        vx *= Math.exp(-7 * dt);
        const flat = Math.min(1, dt * 12);
        const near = (d) => d - 360 * Math.round(d / 360);
        s.fx -= near(s.fx) * flat; s.fy -= near(s.fy) * flat;
        wfx *= Math.exp(-14 * dt); wfy *= Math.exp(-14 * dt); wa *= Math.exp(-6 * dt);
      }
      paint();
      shadow(clamp((fy - s.y) / 300, 0, 1));
      if ((onFloor && Math.abs(vy) < 1 && Math.abs(vx) < 60) || age > 5) { park(); return; }
      anim = requestAnimationFrame(step);
    };
    anim = requestAnimationFrame(step);
  };

  /* ---------- Oct 21: the break. Shards hold for 3 seconds, then turn to particles that float up to the
     menu bar and reassemble into the small ticket there. The menu-bar ticket is then shown with a glow and a
     wiggle (see the Artist Controls section). Once broken it stays in the menu bar for the rest of this browser
     tab, across page changes and refreshes. Tapping the menu-bar ticket brings the page ticket back. ---------- */
  const SETTLE = 3000;
  const markBroken = () => { try { sessionStorage.setItem('gtm-broken', location.pathname); } catch (e) {} };
  const sampleTicket = (() => {
    const NS = 'http://www.w3.org/2000/svg';
    let pth = null;
    return () => {
      if (!pth) {
        const sv = document.createElementNS(NS, 'svg');
        sv.setAttribute('viewBox', '0 0 24 24');
        sv.setAttribute('aria-hidden', 'true');
        sv.style.cssText = 'position:absolute;left:0;top:0;width:24px;height:24px;visibility:hidden;pointer-events:none;';
        pth = document.createElementNS(NS, 'path');
        pth.setAttribute('d', 'M2 7h20v3a2 2 0 0 0 0 4v3H2v-3a2 2 0 0 0 0-4z');
        sv.appendChild(pth);
        document.body.appendChild(sv);
      }
      for (let i = 0; i < 40; i++) {
        const x = rnd(2, 22), y = rnd(7, 17);
        if (!pth.isPointInFill || pth.isPointInFill(new DOMPoint(x, y))) return { x: x, y: y };
      }
      return { x: 12, y: 12 };
    };
  })();
  const easeInOut = (u) => (u < 0.5 ? 4 * u * u * u : 1 - Math.pow(-2 * u + 2, 3) / 2);

  const toParticles = (pieces, wrap) => {
    pieces.forEach((p) => { p.el.style.visibility = 'hidden'; });
    const rect = window.gtmHeaderRect ? window.gtmHeaderRect() : null;
    if (!rect || !rect.width || reduce) {
      wrap.remove();
      window.dispatchEvent(new CustomEvent('gtm:reassembled'));
      return;
    }
    /* map a point of the ticket's own shape (24 x 24 space) onto the menu-bar ticket on screen */
    const S = rect.width * 0.77, off = (rect.width - S) / 2;
    const toScreen = (x, y) => ({ x: rect.left + off + x * (S / 24), y: rect.top + off + y * (S / 24) });
    const parts = [];
    pieces.forEach((p) => {
      const cos = Math.cos(p.a * RAD), sin = Math.sin(p.a * RAD);
      for (let j = 0; j < 5; j++) {
        let u = Math.random(), v = Math.random();
        if (u + v > 1) { u = 1 - u; v = 1 - v; }
        const a = p.tri[0], b = p.tri[1], c = p.tri[2];
        const bx = a[0] + u * (b[0] - a[0]) + v * (c[0] - a[0]) - p.cx;
        const by = a[1] + u * (b[1] - a[1]) + v * (c[1] - a[1]) - p.cy;
        const x0 = p.x + bx * cos - by * sin, y0 = p.y + bx * sin + by * cos;
        const el = document.createElement('div');
        el.className = 'gtm-dot';
        el.style.cssText = 'position:fixed;left:0;top:0;width:3px;height:3px;margin:-1px 0 0 -1px;border-radius:50%;background:#F3DC9A;pointer-events:none;z-index:2147483550;will-change:transform;';
        document.documentElement.appendChild(el);
        const tgt = toScreen(...Object.values(sampleTicket()));
        parts.push({ el, x0, y0, fx: x0 + rnd(-30, 30), fy: y0 - rnd(60, 150), tx: tgt.x, ty: tgt.y, t0: rnd(0, 800), t2: rnd(1400, 2000), ph: Math.random() * 6 });
      }
    });
    wrap.style.display = 'none';
    const FLOAT = 700;
    const end = Math.max(...parts.map((q) => q.t0 + FLOAT + q.t2));
    const b0 = performance.now();
    const loop = (now) => {
      const tt = now - b0;
      parts.forEach((q) => {
        let x = q.x0, y = q.y0;
        if (tt >= q.t0 && tt < q.t0 + FLOAT) {
          const u = (tt - q.t0) / FLOAT, e = 1 - (1 - u) * (1 - u);
          x = q.x0 + (q.fx - q.x0) * e + Math.sin(tt / 120 + q.ph) * 3;
          y = q.y0 + (q.fy - q.y0) * e;
        } else if (tt >= q.t0 + FLOAT) {
          const u = clamp((tt - q.t0 - FLOAT) / q.t2, 0, 1), e = easeInOut(u);
          x = q.fx + (q.tx - q.fx) * e;
          y = q.fy + (q.ty - q.fy) * e;
        }
        q.el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      });
      if (tt < end) { requestAnimationFrame(loop); return; }
      parts.forEach((q) => q.el.remove());
      wrap.remove();
      window.dispatchEvent(new CustomEvent('gtm:reassembled'));
    };
    requestAnimationFrame(loop);
  };

  const shatter = (vx, vy, wa) => {
    cancelAnimationFrame(anim);
    held = null; flying = false; parked = false;
    shattered = true;
    setFalling(false);
    markBroken();
    const r = mini.getBoundingClientRect();
    const ix = r.left + r.width / 2;
    mini.classList.remove('is-flying', 'is-held', 'is-parked');
    mini.classList.add('is-shattered');
    mini.style.animation = 'none';
    mini.style.transform = '';
    mini.style.filter = '';
    save();

    const wrap = document.createElement('div');
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.cssText = 'position:fixed;left:0;top:0;width:0;height:0;z-index:2147483550;pointer-events:none;';
    document.documentElement.appendChild(wrap);

    /* a jittered grid of triangles makes irregular shards that together cover the whole ticket (120 shards) */
    const C = 10, R = 6, bw = r.width, bh = r.height;
    const node = [];
    for (let j = 0; j <= R; j++) {
      node[j] = [];
      for (let i = 0; i <= C; i++) {
        const edgeX = i === 0 || i === C, edgeY = j === 0 || j === R;
        node[j][i] = [i * bw / C + (edgeX ? 0 : rnd(-0.22, 0.22) * bw / C), j * bh / R + (edgeY ? 0 : rnd(-0.22, 0.22) * bh / R)];
      }
    }
    const tris = [];
    for (let j = 0; j < R; j++) {
      for (let i = 0; i < C; i++) {
        const a = node[j][i], b = node[j][i + 1], c = node[j + 1][i], d = node[j + 1][i + 1];
        tris.push([a, b, c], [b, d, c]);
      }
    }

    const pieces = tris.map((t) => {
      const cx = (t[0][0] + t[1][0] + t[2][0]) / 3, cy = (t[0][1] + t[1][1] + t[2][1]) / 3;
      let hy = 0, hw = 0;
      t.forEach((p) => { hy = Math.max(hy, Math.abs(p[1] - cy)); hw = Math.max(hw, Math.abs(p[0] - cx)); });
      const el = mini.cloneNode(true);
      ['hidden', 'href', 'id', 'data-gtm', 'data-close', 'data-backend'].forEach((n) => el.removeAttribute(n));
      el.setAttribute('aria-hidden', 'true');
      el.className = 'gtm gtm-shard';
      const props = {
        position: 'fixed', left: r.left + 'px', top: r.top + 'px', bottom: 'auto', right: 'auto',
        width: bw + 'px', height: bh + 'px', margin: '0',
        transform: 'none', translate: 'none', rotate: 'none', scale: 'none', filter: 'none',
        animation: 'none', transition: 'none', opacity: '1', visibility: 'visible',
        'pointer-events': 'none', 'z-index': '2147483550',
        'transform-origin': cx.toFixed(1) + 'px ' + cy.toFixed(1) + 'px',
        'clip-path': 'polygon(' + t.map((p) => p[0].toFixed(1) + 'px ' + p[1].toFixed(1) + 'px').join(', ') + ')'
      };
      Object.keys(props).forEach((k) => el.style.setProperty(k, props[k], 'important'));
      wrap.appendChild(el);
      const ox = r.left + cx, oy = r.top + cy;
      /* pushed out from where it hit, a little upward kick, and spin from the impact */
      const away = ox - ix;
      return {
        el, ox, oy, x: ox, y: oy, hy, hw, tri: t, cx, cy,
        vx: vx * 0.3 + away * rnd(1.1, 2.0) + rnd(-160, 160),
        vy: -rnd(180, 520) - Math.abs(vy) * 0.12,
        a: 0,
        va: rnd(-700, 700) + wa * 0.4 + away * 0.3
      };
    });

    const G = 2000;
    const t0 = performance.now();
    let last = t0;
    const tick = (now) => {
      const dt = Math.min(0.033, (now - last) / 1000);
      last = now;
      if (now - t0 >= SETTLE) { toParticles(pieces, wrap); return; }
      for (const p of pieces) {
        p.vy += G * dt;
        p.x += p.vx * dt; p.y += p.vy * dt; p.a += p.va * dt;
        p.vx *= Math.exp(-0.5 * dt); p.va *= Math.exp(-1.2 * dt);
        const floor = H() - 6 - p.hy;
        if (p.y > floor) {
          p.y = floor;
          if (p.vy > 120) { p.vy = -p.vy * 0.32; p.vx *= 0.6; p.va *= 0.55; }
          else { p.vy = 0; }
          p.vx *= Math.exp(-7 * dt); p.va *= Math.exp(-9 * dt);
        }
        if (p.x < p.hw) { p.x = p.hw; p.vx = Math.abs(p.vx) * 0.5; }
        if (p.x > W() - p.hw) { p.x = W() - p.hw; p.vx = -Math.abs(p.vx) * 0.5; }
        p.el.style.transform = 'translate(' + (p.x - p.ox).toFixed(1) + 'px,' + (p.y - p.oy).toFixed(1) + 'px) rotate(' + p.a.toFixed(1) + 'deg)';
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  /* bring the ticket back at the bottom of the screen, full size and in one piece */
  const restore = () => {
    shattered = false;
    try { sessionStorage.removeItem('gtm-broken'); sessionStorage.removeItem('gtm-broken-scale'); } catch (e) {}
    mini.classList.remove('is-shattered', 'is-parked', 'is-held', 'is-flying', 'is-tucked');
    parked = false; flying = false; held = null;
    Object.assign(s, { x: 0, y: 0, a: 0, fx: 0, fy: 0, k: 0.5, r: 0 });
    mini.style.animation = 'none';
    paint();
    home();
  };

  const samples = [];
  const nearHome = () => Math.hypot(s.x, s.y);

  /* the ticket can be caught mid-air, and tossed again as many times as you like. */
  mini.addEventListener('pointerdown', (e) => {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    cancelAnimationFrame(anim);
    if (flying) { flying = false; mini.classList.remove('is-flying'); }
    const r = mini.getBoundingClientRect();
    held = {
      id: e.pointerId,
      ox: e.clientX - s.x, oy: e.clientY - s.y,
      sx: e.clientX, sy: e.clientY,
      /* where on the ticket you grabbed it, measured from its center */
      gx: clamp(e.clientX - (r.left + r.width / 2), -r.width / 2, r.width / 2) / s.k,
      gy: clamp(e.clientY - (r.top + r.height / 2), -r.height / 2, r.height / 2) / s.k,
      fromPark: parked
    };
    moved = false;
    samples.length = 0;
    samples.push({ t: performance.now(), x: s.x, y: s.y, a: s.a });
    try { mini.setPointerCapture(e.pointerId); } catch (err) {}
  });

  mini.addEventListener('pointermove', (e) => {
    if (!held || e.pointerId !== held.id) return;
    if (!moved) {
      if (Math.hypot(e.clientX - held.sx, e.clientY - held.sy) < 7) return;
      moved = true;
      mini.classList.add('is-held');
      mini.classList.remove('is-tucked');
      mini.style.animation = 'none';
      slot.classList.add('is-on');
    }
    e.preventDefault();
    let x = e.clientX - held.ox, y = e.clientY - held.oy;
    const d = Math.hypot(x, y);
    /* close to its spot: pulled in like a magnet, and grows back toward full size */
    const pull = clamp(1 - d / (SNAP * 1.6), 0, 1);
    const hot = d < SNAP;
    slot.classList.toggle('is-hot', hot);
    x *= 1 - pull * 0.55; y *= 1 - pull * 0.55;
    s.x = x; s.y = y;
    const w = w0(), h = h0();
    /* held by an edge, it swings toward the direction you pull */
    const tilt = (s.x * (-held.gy / (h / 2)) + s.y * (held.gx / (w / 2))) * 0.12 * (1 - pull);
    s.a = clamp(tilt, -34, 34);
    s.fx = clamp(-(e.clientY - held.sy) * 0.05, -14, 14) * (1 - pull);
    s.fy = clamp((e.clientX - held.sx) * 0.05, -14, 14) * (1 - pull);
    const kTarget = held.fromPark ? 0.8 + pull * 0.2 : 1.07 - pull * 0.07;
    s.k += (kTarget - s.k) * 0.3;
    s.r += (0 - s.r) * 0.35; /* picked up off the bar: it stands up */
    paint();
    shadow(1);
    const now = performance.now();
    samples.push({ t: now, x: s.x, y: s.y, a: s.a });
    while (samples.length > 2 && now - samples[0].t > 110) samples.shift();
  });

  const release = (e) => {
    if (!held || e.pointerId !== held.id) return;
    const g = held; held = null;
    try { mini.releasePointerCapture(e.pointerId); } catch (err) {}
    slot.classList.remove('is-on', 'is-hot');
    if (!moved) return; /* a plain tap: let the link open */
    blockClick = true;
    setTimeout(() => { blockClick = false; }, 450);
    const now = performance.now();
    const first = samples[0], last = samples[samples.length - 1];
    const span = Math.max(16, (last.t - first.t)) / 1000;
    /* finger stopped before letting go: no throw */
    const stale = now - last.t > 90;
    const vx = stale ? 0 : (last.x - first.x) / span;
    const vy = stale ? 0 : (last.y - first.y) / span;
    const va = stale ? 0 : (last.a - first.a) / span;
    const speed = Math.hypot(vx, vy);
    if (nearHome() < SNAP && speed < 1400) { home(); return; } /* dropped in its spot: snap */
    if (!g.fromPark && speed < 520 && nearHome() < Math.min(140, W() * 0.3)) { home(); return; } /* nudged: springs back */
    toss(vx, vy, va, g.gx, g.gy);
  };
  mini.addEventListener('pointerup', release);
  mini.addEventListener('pointercancel', release);
  mini.addEventListener('lostpointercapture', (e) => { if (held && e.pointerId === held.id) release(e); });

  /* a drag is not a tap: don't open the link after throwing or dragging */
  mini.addEventListener('click', (e) => { if (blockClick || flying) { e.preventDefault(); e.stopPropagation(); } }, true);
  mini.addEventListener('dragstart', (e) => e.preventDefault());

  /* keyboard: Escape parks it, Escape again brings it back */
  mini.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || flying) return;
    e.preventDefault();
    mini.style.animation = 'none';
    if (parked) home();
    else toss(rnd(-200, 200), -700, rnd(-100, 100), 0, 0);
  });

  window.addEventListener('resize', () => {
    if (parked && !held && !flying) { s.x = clamp(s.x, -wallX(), wallX()); s.y = floorY(); paint(); }
  });

  /* parked earlier this visit: it's still lying at the bottom */
  let savedX = null;
  try { savedX = sessionStorage.getItem('gtm-parked'); } catch (e) {}
  mini.hidden = false;
  if (savedX !== null && savedX !== '' && !isNaN(+savedX)) {
    parked = true;
    mini.classList.add('is-parked');
    mini.style.animation = 'none';
    Object.assign(s, { a: 0, fx: 0, fy: 0, k: PARK_K, r: 1 });
    s.x = clamp(+savedX, -wallX(), wallX());
    s.y = floorY();
    paint();
    shadow(0);
  }

  /* broken earlier in this tab: it stays in the menu bar across page changes and refreshes (Oct 21) */
  let brokenPage = null;
  try { brokenPage = sessionStorage.getItem('gtm-broken'); } catch (e) {}
  if (brokenPage !== null) {
    shattered = true;
    parked = false;
    setFalling(false);
    try { sessionStorage.removeItem('gtm-parked'); } catch (e) {}
    mini.classList.add('is-shattered');
    setTimeout(() => window.dispatchEvent(new CustomEvent('gtm:reassembled')), 150);
  } else {
    /* it was still in the air when the page changed: it comes back to normal, with no flip-in (Oct 21) */
    try { sessionStorage.removeItem('gtm-falling'); } catch (e) {}
  }

  /* ---------- Oct 20: golden ticket in the menu bar. The button itself is built and placed by the
     Artist Controls section in the header, which also shows it once the ticket has reassembled. ---------- */
  const st = document.createElement('style');
  st.textContent = '.gtm.is-shattered{visibility:hidden !important;pointer-events:none !important}' +
    '.gtm-menu-btn{display:inline-flex;align-items:center;justify-content:center;width:40px;height:40px;padding:0;margin:0;background:none;border:0;cursor:pointer;color:inherit;-webkit-tap-highlight-color:transparent}' +
    '.gtm-menu-btn:focus-visible{outline:2px solid currentColor;outline-offset:2px;border-radius:4px}' +
    '.gtm-menu-btn svg{width:22px;height:22px;display:block;filter:drop-shadow(0 1px 1px rgba(0,0,0,.25))}';
  document.head.appendChild(st);
  const search = document.querySelector("header a[href*='search'], header button[aria-label*='earch' i], header summary[aria-label*='earch' i], header [class*='search'] button");
  const host = (search && search.parentElement) || document.querySelector('header .header-actions') || null;
  if (host) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gtm-menu-btn';
    btn.setAttribute('aria-label', 'Show the golden ticket');
    btn.title = 'Golden ticket';
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><defs><linearGradient id="gtmg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#B8893A"/><stop offset=".4" stop-color="#F3DC9A"/><stop offset="1" stop-color="#C9A14E"/></linearGradient></defs><path d="M2 7h20v3a2 2 0 0 0 0 4v3H2v-3a2 2 0 0 0 0-4z" fill="url(#gtmg)"/><path d="M15 7v10" stroke="#2A1626" stroke-dasharray="2 2" stroke-width="1"/></svg>';
    btn.addEventListener('click', () => {
      mini.classList.remove('is-tucked');
      if (shattered) restore();
      else if (parked) home();
    });
    host.insertBefore(btn, search && search.parentElement ? search : host.firstChild);
  }
})();
